export const inovaWriteDescription =
  'Connecting with Inova allows potential new hires to automatically sync from Team Engine to Inova and will send a notification to the applicant to complete their remaining onboarding tasks.';

export const inovaEditDescription = `To connect with Inova, please provide your Inova company short name, the status change you would like this sync to occur, and whether you want to add the new hire as an applicant or employee in Inova. Learn where to find your short name and more information on the integration`;

export const inovaReadDescription =
  "Syncing with Inova's HR system allows you to automatically sync employees from Inova into your Team Engine directory.";
